exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tag-slot{margin:5px 0}.trending{background:#588041;overflow:auto;padding:.75rem}.trending-header{color:#fff;font-size:1.6rem;margin:.6rem 0;margin-bottom:1rem;text-align:center}.trending-elements-container{background:#fff;padding:0 1rem}.trending-element:last-child{border:none}.trending-element{display:flex;border-bottom:1px solid #a9a9a9;padding:1rem .5rem}.trending-element:hover .trending-title>span{color:#77a95c}.trending-index{flex:4rem 0 0;font-weight:700;line-height:normal}.trending-index>img{box-shadow:-2px 2px 3px 1px rgba(0,0,0,.39)}.trending-title{padding-left:.5rem;font-size:1rem;line-height:normal;color:#585858}.trending-title>span{color:inherit}.trending-title>span.notice{display:block;color:#588041}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-51d3ccb1","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/article/trending.vue
// module id = 123
// module chunks = 4